import React, { useEffect, useState, Suspense } from 'react';
import Button from '../../atoms/Button';
import { ErrorWrapper } from '../../../components/Error';
import { bodySmall } from '../../commonStyles/Fonts';
import { styled } from '../../../stitches.config';
import { pushDataLayer } from '../../../helpers';
import { useLocation } from 'react-router-dom';
import ErrorPlaceholder from './ErrorPlaceholder';

const ErrorPage = React.lazy(() => import(/* webpackChunkName: "redesign__pages__error-pages__ErrorPage" */ './ErrorPage'));

interface IErrorReactPage {
    resetError: () => void;
};

const ErrorReactPage: React.FC<IErrorReactPage> = ({ resetError }) => {

    const location = useLocation();

    const [isInit, setInit] = useState(false);

    useEffect(() => {
        setInit(true);
        document.getElementById('articleContentInSource')?.remove();

        pushDataLayer({
            'event': 'virtualPageview',
            'virtualPageURL': window.location.pathname,
            'virtualPageTitle': 'Wystąpił błąd aplikacji',
            'pageType': 'Błąd aplikacji'
        });
    }, []);

    useEffect(() => {
        if (!isInit)
            return;
        resetError();
    }, [location]);

    return (
        <ErrorWrapper>
            <Suspense fallback={<ErrorPlaceholder />}>
                <ErrorPage description={(
                    <p>
                        Wystąpił błąd, odśwież stronę aby spróbować ponownie.
                    </p>
                )} />
            </Suspense>
            <UnderErrorWrapper>
                <Button
                    onClick={() => window.location.reload()}
                    text="Odśwież"
                    starPosition="none"
                />
                <p className={bodySmall()}>
                    Jeśli problem ciągle występuje daj znam znać: <a href="mailto:support@natemat.pl">support@natemat.pl</a>
                </p>
            </UnderErrorWrapper>
        </ErrorWrapper>
    );

};

export default ErrorReactPage;

const UnderErrorWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '$grayscale0',
    color: '$grayscale100',
    marginTop: "20px",

    "p": {
        "a": {
            color: '$grayscale100 !important',
        }
    }
});
